var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "info-header", style: { height: _vm.imgHeight } },
          [
            _c(
              "mt-swipe",
              { attrs: { auto: 5000 } },
              _vm._l(_vm.highlightList, function(item) {
                return _c("mt-swipe-item", { key: item.infoid }, [
                  _c("div", { staticClass: "img" }, [
                    _c("img", {
                      attrs: { src: item.coverurl },
                      on: {
                        click: function($event) {
                          _vm.showInfoDetail(item)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text text-left px-2" }, [
                    _vm._v(_vm._s(item.title))
                  ])
                ])
              })
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "info-block-list text-left" }, [
          _c("div", [
            !!_vm.data.news
              ? _c("div", { staticClass: "info-block py-4" }, [
                  _c("div", { staticClass: "info-block-type color-default" }, [
                    _c("div", { staticClass: "x-row" }, [
                      _c("div", { staticClass: "x-col-6" }, [
                        _vm._v("新闻中心")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "x-col-6 text-right info-more" },
                        [
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  _vm.showMore("NEWS")
                                }
                              }
                            },
                            [_vm._v("更多")]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "info-list" },
                    _vm._l(_vm.data.news.items, function(item) {
                      return _c(
                        "div",
                        { key: item.infoid, staticClass: "info-item" },
                        [
                          !!item.title
                            ? _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "clampy",
                                      rawName: "v-clampy",
                                      value: 1,
                                      expression: "1"
                                    }
                                  ],
                                  staticClass: "clamp-text",
                                  on: {
                                    click: function($event) {
                                      _vm.showInfoDetail(item)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(item.title))]
                              )
                            : _vm._e()
                        ]
                      )
                    })
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            !!_vm.data.training
              ? _c("div", { staticClass: "info-block py-4" }, [
                  _c("div", { staticClass: "info-block-type color-default" }, [
                    _c("div", { staticClass: "x-row" }, [
                      _c("div", { staticClass: "x-col-6" }, [
                        _vm._v("培训动态")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "x-col-6 text-right info-more" },
                        [
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  _vm.showMore("TRAINING")
                                }
                              }
                            },
                            [_vm._v("更多")]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "info-list" },
                    _vm._l(_vm.data.training.items, function(item) {
                      return _c(
                        "div",
                        { key: item.infoid, staticClass: "info-item" },
                        [
                          !!item.title
                            ? _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "clampy",
                                      rawName: "v-clampy",
                                      value: 1,
                                      expression: "1"
                                    }
                                  ],
                                  staticClass: "clamp-text",
                                  on: {
                                    click: function($event) {
                                      _vm.showInfoDetail(item)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(item.title))]
                              )
                            : _vm._e()
                        ]
                      )
                    })
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            !!_vm.data.extraReading
              ? _c("div", { staticClass: "info-block py-4" }, [
                  _c("div", { staticClass: "info-block-type color-default" }, [
                    _c("div", { staticClass: "x-row" }, [
                      _c("div", { staticClass: "x-col-6" }, [
                        _vm._v("扩展阅读")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "x-col-6 text-right info-more" },
                        [
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  _vm.showMore("EXTRAREADING")
                                }
                              }
                            },
                            [_vm._v("更多")]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "info-list" },
                    _vm._l(_vm.data.extraReading.items, function(item) {
                      return _c(
                        "div",
                        { key: item.infoid, staticClass: "info-item" },
                        [
                          !!item.title
                            ? _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "clampy",
                                      rawName: "v-clampy",
                                      value: 1,
                                      expression: "1"
                                    }
                                  ],
                                  staticClass: "clamp-text",
                                  on: {
                                    click: function($event) {
                                      _vm.showInfoDetail(item)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(item.title))]
                              )
                            : _vm._e()
                        ]
                      )
                    })
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            !!_vm.data.course
              ? _c("div", { staticClass: "info-block py-4" }, [
                  _c("div", { staticClass: "info-block-type color-default" }, [
                    _c("div", { staticClass: "x-row" }, [
                      _c("div", { staticClass: "x-col-6" }, [
                        _vm._v("开班信息")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "x-col-6 text-right info-more" },
                        [
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  _vm.showMore("")
                                }
                              }
                            },
                            [_vm._v("更多")]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "info-list" },
                    _vm._l(_vm.data.course.items, function(item, index) {
                      return index <= 4
                        ? _c(
                            "div",
                            { key: item.groupid, staticClass: "info-item" },
                            [
                              !!item.schoolname
                                ? _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "clampy",
                                          rawName: "v-clampy",
                                          value: 2,
                                          expression: "2"
                                        }
                                      ],
                                      staticClass: "clamp-text"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(item.schoolname) +
                                          ":<" +
                                          _vm._s(item.courseName) +
                                          ">新班<" +
                                          _vm._s(item.groupname) +
                                          ">,开班了!"
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    })
                  )
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("footer-nav")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f4a4238", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f4a4238","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/information/information.vue
// module id = null
// module chunks = 